import React from 'react';
import styled from 'styled-components';
import { IoCheckmark, IoChatboxEllipses } from 'react-icons/io5';
import { IoIosDocument, IoIosWarning } from 'react-icons/io';
import { HiCursorClick } from 'react-icons/hi';
import { FaInfo } from 'react-icons/fa6';
import { DraggableComponents } from '../../../../common/types/checkout';

type Props = {
  component: DraggableComponents;
};

export const GuaranteeBadge: React.FC<Props> = ({ component }) => {
  const getIcon = () => {
    switch (component?.configurations?.advantages?.icon) {
      case 'check':
        return <IoCheckmark />;
      case 'chat':
        return <IoChatboxEllipses />;
      case 'document':
        return <IoIosDocument />;
      case 'cursor':
        return <HiCursorClick />;
      case 'warning':
        return <IoIosWarning />;
      case 'info':
        return <FaInfo />;
    }
  };
  return (
    <GuaranteeContainer color={component?.configurations?.advantages?.color}>
      <CheckIcon color={component?.configurations?.advantages?.color}>
        {getIcon()}
      </CheckIcon>
      <GuaranteeContent>
        <GuaranteeTitle>
          {component?.configurations?.advantages?.title}
        </GuaranteeTitle>
        <GuaranteeSubtitle color={component?.configurations?.advantages?.color}>
          {component?.configurations?.advantages?.subtitle}
        </GuaranteeSubtitle>
      </GuaranteeContent>
    </GuaranteeContainer>
  );
};

const GuaranteeContainer = styled.div<{ color: string }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: white;
  border: 2px solid ${({ color }) => color};
  border-radius: 8px;
  margin: 16px 0;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;

  @media (max-width: 400px) {
    gap: 10px;
    padding: 12px;
  }
`;

const CheckIcon = styled.div<{ color: string }>`
  width: 48px;
  height: 48px;
  min-width: 48px;
  background: ${({ color }) => color};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: bold;
  flex-shrink: 0;

  @media (max-width: 400px) {
    width: 40px;
    height: 40px;
    min-width: 40px;
    font-size: 20px;
  }
`;

const GuaranteeContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const GuaranteeTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #000;
  overflow-wrap: break-word;
  word-break: break-word;

  @media (max-width: 400px) {
    font-size: 16px;
  }
`;

const GuaranteeSubtitle = styled.p<{ color: string }>`
  margin: 0;
  font-size: 16px;
  color: ${({ color }) => color};
  overflow-wrap: break-word;
  word-break: break-word;

  @media (max-width: 400px) {
    font-size: 14px;
  }
`;
